import React, { useEffect, useState } from 'react'
import styled from "styled-components"
import axios from 'axios'

import StepIcon from '../../../assets/images/svg/back-arrow.svg';

const Container = styled.div`
  padding: 0 8px;
`

const Header = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 24px;

  span {
    font-size: 14px;
    line-height: 14px;
    margin-left: 6px;
  }
`

const Content = styled.div`
  height: 235px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  h4 {
    margin-bottom: 8px
  }

  p {
    font-weight: normal;
    font-size: 14px;
    line-height: 1.5;
    color: #285056;
  }
`
const Footer = styled.div`
  div:last-child {
    margin-bottom: 0;
  }

  div {
    margin-bottom: 16px;

    input {
      width: calc(100% - 16px);
      height: 30px;
      padding: 4px 8px;
      font-family: var(--regular-font);
      font-size: 14px;
      border: 1px solid #EEF2F5;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03);
      border-radius: 6px;
      outline: none;
  
      &:focus {
        border: 1px solid rgba(130, 130, 130, 0.2);
        outline: none;
      }
    }

    label {
      font-family: var(--graphik-medium);
      font-weight: 500;
      font-size: 13px;
    }
  
    button {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
`

const Spinner = styled.span`
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  border-top: 2px solid #fff;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

const StepFour = props => {

  const url = process.env.GATSBY_MIDDLEWARE_URL
  const [loading, setLoading] = useState(false)
  const [retry, setRetry] = useState(false)
  const [cachedResponse, setcachedResponse] = useState(false)

  const setCodeString = () => {
    const curl = `curl https://api.paystack.co/transaction/verify/${props.request.reference} 
    -H "Authorization: Bearer ${props.secretKey}"
    -X GET
    `
    
    props.updateCode(curl)
    props.updateLanguage('bash')
  }

  const checkRecap = () => {
    if(Object.keys(props.recap).length === 0 && props.recap.constructor === Object) {
      setcachedResponse(false)
    } else {
      setcachedResponse(true)
    }
  }

  const loadCachedResponse = () => {
    let response = props.recap.verify.response
    updateUI(response)
  }

  const verifyTransaction = () => {
    if(cachedResponse) {
      loadCachedResponse()
    } else{
      setLoading(true)
      axios.get(`${url}/transaction/verify/${props.request.reference}`).then(res => {
        if(res.data.data.status === 'success') {
          updateUI(res.data)
        } else {
          setLoading(false)
          setRetry(true)
        }
      }).catch(error => {
        props.updateCode(JSON.stringify(error.response.data.message, null, '  '))
        props.updateLanguage('json')
        setLoading(false)
      })
    }
  }

  const updateUI = (response) => {
    props.updateAuthCode(response.data.authorization.authorization_code)
    props.updateCode(JSON.stringify(response, null, '  '))
    props.updateLanguage('json')
    setLoading(false)
    props.changeStep(5)
  }

  const retryPayment = () => {
    props.changeStep(3)
  }

  useEffect(() => {
    props.setHeight('235px')
    setCodeString()
    checkRecap()
  }, [])

  return (
    <Container>
      <Header onClick={() => props.changeStep(3)}>
        <StepIcon />
        <span>Back</span>
      </Header>
      <Content>
        <div>
          <h4>Verify Transaction</h4>
          <p>After a transaction has been completed, use the verify endpoint to confirm that the transaction was successful</p>
        </div>
        <Footer>
          <div>
            <button className="button" onClick={() => verifyTransaction()} disabled={loading}>
              {loading ? <Spinner /> : cachedResponse ? 'Next' : 'Verify Transaction' }
            </button>
          </div>
          {retry ? (
            <div>
              <button className="button-inverse" onClick={() => retryPayment()} disabled={loading}>
                {loading ? <Spinner /> : 'Retry Payment' }
              </button>
            </div>
          ) : ('')
          }
        </Footer>
      </Content>
    </Container>
  )
}


export default StepFour